import { requestJson, buildQuery } from "./apiClient";

function iamBase(clientViewId) {
  return `/api/admin/client-views/${encodeURIComponent(clientViewId)}/iam`;
}

export function getClientViewIamSummary(clientViewId) {
  return requestJson(`${iamBase(clientViewId)}/summary`);
}

export function listClientViewIamUsers(clientViewId, params = {}) {
  return requestJson(`${iamBase(clientViewId)}/users${buildQuery(params)}`);
}

export function inviteClientViewIamUser(clientViewId, body) {
  return requestJson(`${iamBase(clientViewId)}/users/invite`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function patchClientViewIamUserStatus(clientViewId, clientUserId, body) {
  return requestJson(`${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/status`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function updateClientViewIamAssignment(clientViewId, assignmentId, body) {
  return requestJson(`${iamBase(clientViewId)}/assignments/${encodeURIComponent(assignmentId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function listClientViewIamRoles(clientViewId) {
  return requestJson(`${iamBase(clientViewId)}/roles`);
}

export function listClientViewIamPermissions(clientViewId) {
  return requestJson(`${iamBase(clientViewId)}/permissions`);
}

export function createClientViewIamRole(clientViewId, body) {
  return requestJson(`${iamBase(clientViewId)}/roles`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateClientViewIamRole(clientViewId, iamRoleId, body) {
  return requestJson(`${iamBase(clientViewId)}/roles/${encodeURIComponent(iamRoleId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function deleteClientViewIamRole(clientViewId, iamRoleId) {
  return requestJson(`${iamBase(clientViewId)}/roles/${encodeURIComponent(iamRoleId)}`, {
    method: "DELETE",
  });
}

export function listClientViewIamAvailableOrganizations(clientViewId, params = {}) {
  return requestJson(`${iamBase(clientViewId)}/organizations/available${buildQuery(params)}`);
}

export function assignOrganizationToClientView(clientViewId, body) {
  return requestJson(`${iamBase(clientViewId)}/organizations`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function removeOrganizationFromClientView(clientViewId, assignmentId) {
  return requestJson(`${iamBase(clientViewId)}/organizations/${encodeURIComponent(assignmentId)}`, {
    method: "DELETE",
  });
}

export function listClientViewIamAuditLog(clientViewId, params = {}) {
  return requestJson(`${iamBase(clientViewId)}/audit-log${buildQuery(params)}`);
}

export function resetClientViewIamUserPassword(clientViewId, clientUserId, body = {}) {
  return requestJson(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/password-reset`,
    {
      method: "POST",
      body: JSON.stringify(body),
    }
  );
}

export function setClientViewIamUserTemporaryPassword(clientViewId, clientUserId, body = {}) {
  return requestJson(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/temporary-password`,
    {
      method: "POST",
      body: JSON.stringify(body),
    }
  );
}

export function getClientViewIamUserLoginHistory(clientViewId, clientUserId, params = {}) {
  return requestJson(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/login-history${buildQuery(params)}`
  );
}

export function updateClientViewIamUserRole(clientViewId, clientUserId, body) {
  return requestJson(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/role`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
}
